export default class WindowAdapter {
  static locationSearch(){
    return window.location.search;
  }

  static locationHost(){
    return window.location.host;
  }

  static locationPathname(){
    return window.location.pathname;
  }
}
